module.exports = {"owner_financing_provided":"Seller willing to offer owner financing","seller_commission_disclaimer":"If entered, will be shown to every potential buyer as part of \"Letter of Intent\"; if left empty or 0, it will not be shown."}


//////////////////
// WEBPACK FOOTER
// ./src/app/@propnow/locales/pri/en.json
// module id = 461
// module chunks = 244